<template lang="pug">
    #RcmTable
        Card
            // table上方工具列（此樣式有兩種版本）
            // 版本一：
            Row(type="flex" justify="space-between" v-if="!withIcon &&actionInTable")
                Col
                    Button.button(type="primary" v-if="userCanCreate" @click="createItem" :disabled="isCreateBtnDisabled") {{ $t("global.create") }}
                    Button.button(type="primary" v-if="userCanBatchEdit" @click="clickBatchEdit" :disabled="isBatchEditBtnDisabled") {{ $t("rcmtable.batchText") }} {{$t("rcmtable.editText")}}
                    Button(type="dashed" v-if="userCanBatchDelete" @click="clickBatchDelete" :disabled="isBatchDeleteBtnDisabled") {{ $t("rcmtable.batchText") }} {{$t("rcmtable.deleteText")}}
                    slot(name="tableUpperBtn")
                Col.flex
                    TagSelector(:indexName="esIndex" v-model="searchFilterForm.tags" v-if="userCanSearchByTag" @input="getFilterResult" :isUseWithStore="false" style="width:200px")
                    GroupNameSelector(:indexName="esIndex" v-model="searchFilterForm.groupName" v-if="userCanSearchByGroup" @input="getFilterResult" :isUseWithStore="false" style="width:200px")
                    EdgeNameSelector(:indexName="esIndex" v-model="searchFilterForm.hostName" v-if="userCanSearchByEdge" @input="getFilterResult" :isUseWithStore="false" style="width:200px")
                    SearchDomainAtProfileInput(v-if="userCanSearchDomain"
                            v-model="domainName"
                            :searchSize="pageSize"
                            :isFuzzySearch="isFuzzySearch"
                            placeholder="Search Domain Name"
                            @loading="isTableLoading = $event"
                            @result="onSearchDomainAtProfileResult"
                            @error="onSearchDomainAtProfileError")
                    Input(v-if="primarySearchKey" search :placeholder="`Search  ${primarySearchKeyI18}`" v-model="searchFilterForm[primarySearchKey]" style="width: 200px" @on-search="getFilterResult")
                    Checkbox(v-if="userCanToggleFuzzySearch" v-model="isFuzzySearch") {{ $t("rcmtable.isFuzzySearch")}}
                Col
                    Row
                        Badge(dot :count="hasUserInputFilter")
                            Button(v-if="userCanEditFilters" @click="showFiltersForm") {{ $t("rcmtable.showFilters")}}
                        Button(v-if="userCanEditColumns" @click="showColumnsForm") {{$t("rcmtable.showCols")}}
                        div(v-if="userCanExport")
                            div(v-if="searchView=='AppProfile'")
                                Button(@click="exportAppProfileModal = true") {{ $t("rcmtable.export")}}
                                Modal(v-model="exportAppProfileModal" :title='$t("rcmtable.appProfileExportTitle")' @on-ok="fetchExportData" footer-hide=true)
                                    Row(type="flex" justify="space-between")
                                        RadioGroup(v-model="exportAppProfileType")
                                            Radio(label="exportAppProfile")
                                                span {{ $t("rcmtable.exportAppProfile") }}
                                            Radio(label="exportAppProfileDomain")
                                                span {{ $t("rcmtable.exportAppProfileDomain") }}
                                    Row(type="flex" justify="end")
                                        Button(@click="exportAppProfileModal = false")
                                            download-excel(:fields="exportFields" :name="searchView?searchView+'.csv':'exportData.csv'" type="csv" :fetch="fetchExportData") {{ $t("rcmtable.export")}}
                            div(v-else)
                                Button
                                    download-excel(:fields="exportFields" :name="searchView?searchView+'.csv':'exportData.csv'" type="csv" :fetch="fetchExportData") {{ $t("rcmtable.export")}}
                        //- ImportBtn(v-if="isImportCSV" :searchView="searchView" :esIndexFields="esIndexFields" :formData="searchFilterForm" :formInitFieldsData="initFieldsData"  @searchDomainAtProfile="searchDomainAtProfile")
            // 版本二：以下為ＳＳ樣式，若上方版本一有調整，請同步更新此區的對應程式碼
            Row(type="flex" justify="space-between" v-if="withIcon &&actionInTable")
                Col.flex
                    Badge(dot :count="hasUserInputFilter")
                        Tooltip(:content="$t('rcmtable.showFilters')" placement="top")
                            Button.tableBtn(size="large" icon="md-options" @click="showFiltersForm" v-if="userCanEditFilters")
                    Tooltip(:content="$t('rcmtable.showCols')" placement="top")
                        Button.tableBtn(size="large" icon="md-settings" @click="showColumnsForm" v-if="$store.state.userData.privilege !== 'normaluser'&&userCanEditColumns")
                    Tooltip(:content="$t('rcmtable.export')" placement="top" v-if="userCanExport")
                        download-excel(:fields="exportFields" :name="searchView?searchView+'.csv':'exportData.csv'" type="csv" :fetch="fetchExportData" title="''")
                            Button.tableBtn(size="large" icon="md-cloud-download")
                    Button.tableBtn(v-if="userCanAdjustTableSize" size="large" icon="md-reorder" @click="tableSize='small'" :style="tableSize=='small'?'color:#b7b7b7':'color:black'")
                    Button.tableBtn(v-if="userCanAdjustTableSize" size="large" icon="md-menu" @click="tableSize='default'" :style="tableSize=='default'?'color:#b7b7b7':'color:black'")
                Col.flex
                    TagSelector(:indexName="esIndex" v-model="searchFilterForm.tags" v-if="userCanSearchByTag" @input="getFilterResult" style="width:200px" :isUseWithStore="false" :placeholder="$t('domainsetting.tags')")
                    SearchDomainAtProfileInput(v-if="userCanSearchDomain"
                            v-model="domainName"
                            :searchSize="pageSize"
                            :isFuzzySearch="isFuzzySearch"
                            placeholder="Search Domain Name"
                            @loading="isTableLoading = $event"
                            @result="onSearchDomainAtProfileResult"
                            @error="onSearchDomainAtProfileError")
                    Input(v-if="primarySearchKey" search :placeholder="`Search  ${primarySearchKeyI18}`" v-model="searchFilterForm[primarySearchKey]" style="width: 200px" @on-search="getFilterResult")
                    Checkbox(v-if="userCanToggleFuzzySearch" v-model="isFuzzySearch") {{ $t("rcmtable.isFuzzySearch")}}
                Col.flex
                    slot(name="tableUpperBtn")
                    Button.cardBtn(size="large" icon="md-create" v-if="userCanCreate" @click="createItem") {{ addButtonText }}
                    Button.cardBtn(size="large" v-if="userCanBatchEdit" @click="clickBatchEdit") {{ $t("rcmtable.batchText") }} {{$t("rcmtable.editText")}}
                    Button(size="large" style="color: #e1e1e1" type="dashed" v-if="userCanBatchDelete" @click="clickBatchDelete") {{ $t("rcmtable.batchText") }} {{$t("rcmtable.deleteText")}}
            // table本人
            Table.table(:class="tableHeaderStyle" ref="mainTable" :border="withBorder" style="margin-top: 8px;text-overflow: ellipsis" :columns="tableColumns" :data="tableData" :loading="isTableLoading" :row-class-name="rowClassName" :size="tableSize" @on-sort-change="onRcmTableSortchange")
            // table下方 page組件
            Row
                span(:style="totalCountStyle") {{ $t('rcmtable.totalDataCountText') }} {{ tableDataTotal }}
                Page(:styles="paginationStyle" show-sizer :total="tableDataTotal < currentTableDataCapacity ? tableDataTotal : currentTableDataCapacity" :page-sizer-text="$t('rcmtable.page')" :page-size="pageSize" :current="pageCurrent" @on-change="changePage" @on-page-size-change="changePageSize")
                // table下方 page組件 載入更多
                template(v-if="showSearchAfterBtn")
                    Tooltip(:content="$t('rcmtable.searchAfterBtnTooltip', { lastPage: maxPageForLegacyPagination })" placement="top" theme="light" max-width=150)
                        Button(@click="getSearchAfterTableData" :loading="isTableLoading") {{ $t("rcmtable.searchAfterBtnText") }}
        // filter表單
        component(v-if="userCanEditFilters" :is="tableWithModal?'Modal':'Drawer'"  title="Filters" v-model="isFilterShown" :width="tableWithModal?70:30"  :mask-closable="tableWithModal?false:true" transfer  :styles="tableWithModal ? formModalStyles:formDrawerStyles")
            Form(ref="searchFilterForm" :model="searchFilterForm" label-position="left" :label-width="180")
                FormItem.filterFormItem(v-for="(item,key) in allFilterFormItems" :key="key" :label="item.title" :prop="item.key")
                    component(:is="item.filter.formRender" :formOptions="item.filter.options" :multiple="item.filter.multiple" :formItem="item" v-model="searchFilterForm[item.key]" :formData="searchFilterForm")
            .footer(:class="tableWithModal?'footerActionRight' : 'footerActionLeft'")
                Button.button(@click="clearFilter") Clear
                Button(type="primary" @click="getFilterResult") Search

        // columns表單
        component(v-if="userCanEditColumns" :is="tableWithModal?'Modal':'Drawer'"  title="Columns" v-model="isColumnShown" :width="tableWithModal?70:30"  :mask-closable="tableWithModal?false:true" transfer  :styles="tableWithModal ? formModalStyles:formDrawerStyles")
            List
                ListItem(v-for="option,key in allColumns" :key="key")
                    Checkbox(v-model="option.showInTable") {{ option.title }}
            .footer(:class="tableWithModal?'footerActionRight' : 'footerActionLeft'")
                Button(type="primary" @click="saveColumns" :disabled="isSaveBtnDisabled") Apply

        // batch編輯表單
        component(:is="tableWithModal?'Modal':'Drawer'"  title="Batch Edit" v-model="isBatchEditFormShown" width="70"  :mask-closable="tableWithModal?false:true" transfer  :styles="tableWithModal ? formModalStyles:formDrawerStyles")
            BatchEditForm(ref="BatchEditForm"
                :esIndex="esIndex"
                :allFormItems="allFormItems"
                :batchSelector="batchSelector"
                v-if="isBatchEditFormShown"
                @batchEditSubmitComplete="batchEditSubmitComplete"
                :batchSelectorWith="batchSelectorWith"
                :editingItems="editingItems"
                :givenBatchSearchFilters="givenBatchSearchFilters")

        // batch刪除表單
        component(:is="tableWithModal?'Modal':'Drawer'"  title="Batch Delete" v-model="isBatchDeleteFormShown" width="70"  :mask-closable="tableWithModal?false:true" transfer  :styles="tableWithModal ? formModalStyles:formDrawerStyles")
            BatchDeleteForm(
                :esIndex="esIndex"
                :batchSelector="batchSelector"
                v-if="isBatchDeleteFormShown"
                @batchDeleteSubmitComplete="batchDeleteSubmitComplete"
                :batchSelectorWith="batchSelectorWith"
                :givenBatchSearchFilters="givenBatchSearchFilters")

        // 新增編輯表單
        component(:class="tableWithModal?'modalForm': ''" :is="tableWithModal?'Modal':'Drawer'"  :title="formTitle" v-model="isFormShown" width="70"  :mask-closable="tableWithModal?false:true" transfer  :styles="tableWithModal ? formModalStyles:formDrawerStyles" @on-close="cancelEdit" @on-cancel="cancelEdit" :ok-text="$t('rcmtable.submitText')" :cancel-text="$t('rcmtable.cancelText')" :loading="modalLoading")
            Row(v-if="withFormExamples" style="margin: 24px 16px;")
                Col(span="8")
                    Icon(type="md-flame" size="20" style="float: left; margin-right: 5px; color: orange")
                    h3 Choose From Our Examples
                        span
                            Icon(type="md-arrow-forward")
                Col(span="16")
                    //- component(v-if="isFormShown" :is="formExampleComponents" @selectExample="delete $event[primarySearchKey]; formData = Object.assign(formData, $event);")
                    component(v-if="isFormShown" :is="formExampleComponents" :formData="formData" :selectFileData="selectFileData" @selectExample="selectExample($event)")
            Form(ref="form" :model="formData" label-position="left" :label-width="250")
                .formDescription(v-html="formDescription" v-if="!tableWithModal")
                Collapse(:simple="tableWithModal?false:true" ref="formCollapse" v-model="formSectionCollapse" )
                    template(v-for="section,key in formSections")
                        Panel(:name="section.sectionKey" v-show="isPanelShown(key,formData)")
                            strong {{ section.sectionName }}
                            div.section-description(v-if="section.sectionDescription && !tableWithModal" v-html="section.sectionDescription" slot="content")
                            FormItem(
                                v-for="(sectionItem) in section.sectionItems"
                                :key="sectionItem.key" slot="content"
                                v-show="sectionItem.vShowFieldVal(formData)==1"
                                :prop="sectionItem.key"
                                :rules="sectionItem.vShowFieldVal(formData)==1 ? sectionItem.validate : []")
                                div(slot="label")
                                    Row(align="middle")
                                        Col
                                            h3 {{sectionItem.title}}
                                        Col
                                            component(:is="sectionItem.explainPoptip" v-if="sectionItem.explainPoptip" :explainPoptipProps="sectionItem.explainPoptipProps" :explainPoptipWithTable="sectionItem.explainPoptipWithTable")
                                    .formItemDescription(v-html="sectionItem.description" v-if="!tableWithModal")
                                component(
                                        :is="sectionItem.formRender"
                                        v-model="formData[sectionItem.key]"
                                        :formData="formData"
                                        :formItem="sectionItem"
                                        :editingItems="editingItems"
                                        @modalSubmitComplete="getTableData"
                                        @setSelectFileData="setSelectFileData($event)"
                                        @codeChangedNotSave="codeChangedNotSave")
                    .footer(:class="tableWithModal?'footerActionRight' : 'footerActionLeft'")
                        Button(@click="cancelEdit" v-if="tableWithModal") {{ $t("rcmtable.cancelText") }}
                        Button(:style="tableWithModal?'':'width:50%'" type="primary" @click="validateFormAndSubmit(esIndex)" :disabled="isEditBtnDisabled" :loading="isEditBtnLoading") {{ $t("rcmtable.saveText") }}

        Modal(v-model="$store.state.isPaymentOpened"  @on-cancel="closeModalEvent" footer-hide width="700")
            div(slot="header" style="display: flex; flex-direction: row; align-items: center; font-size: 20px")
                Icon(type="ios-alert-outline" color="#00C08B" size="36")
                span {{modalTitle}}
            //- pre 你的{{objectName}}用量已達試用方案 [{{planName}}] 上限。
            //- | 你可以立即結束試用並訂閱方案，即可繼續新增物件，並使用平台來管理你的服務。
            pre {{modalBody.descriptionOne}}
            pre {{modalBody.descriptionTwo}}
            Row(type="flex" justify="end")
                Col(style="width: 240px;text-align: right;")
                    Button.cardBtn(@click="closeModalEvent" ) {{ $t('accountInfo.remind.continueTrialBtnText') }}
                    Button.cardBtn(type="primary" @click="openPaymentModal") {{ $t('accountInfo.error.setBtnText') }}

</template>
<script>
import fieldsData from "@/data/rcmtableFieldsV2";
// import fieldsSections from "@/data/rcmtableSections"

import bus from "@/libs/bus.js";
import { getEsData, _updateData, _batchUpdateData, _batchDeleteData } from "@/api/esdata";
import { getFormOptions } from "@/api/formoptions";

import { formItemCompletion, columnItemCompletion, filterItemCompletion } from "@/libs/rcmTableFieldsFunction";
import { diff } from "json-diff";

import FormInput from "./rcmTableFormItems/Input";
import FormInputNumber from "./rcmTableFormItems/InputNumber";
import FormSelect from "./rcmTableFormItems/Select/index.js";
import FormSwitch from "./rcmTableFormItems/Switch";
import FormCheckboxGroup from "./rcmTableFormItems/CheckboxGroup";
import FormRadioGroup from "./rcmTableFormItems/RadioGroup";
import FormUpload from "./rcmTableFormItems/Upload";
import FormTransfer from "./rcmTableFormItems/Transfer";
import FormRange from "./rcmTableFormItems/Range";
import FormBoolean from "./rcmTableFormItems/Boolean";
import FormDatePicker from "./rcmTableFormItems/DatePicker";
import TwoListDraggable from "./rcmTableFormItems/TwoListDraggable";
import OneListDraggable from "./rcmTableFormItems/OneListDraggable";
import TableList from "./rcmTableFormItems/TableList";
import TableCheckbox from "./rcmTableFormItems/TableCheckbox";
import RawHTML from "./rcmTableFormItems/RawHTML";
import TextOnly from "./rcmTableFormItems/TextOnly";
import HtmlPreview from "@/components/rcmTableFormItems/HtmlPreview";
import CodeEditor from "@/components/rcmTableFormItems/CodeEditor";
import CodeEditorV2 from "@/components/rcmTableFormItems/CodeEditorV2";
import CodeEditorV3 from "@/components/rcmTableFormItems/CodeEditorV3";
import WafHeaderListInput from "@/components/rcmTableFormItems/WafHeaderListInput";
import wafJa3HashesInput from "@/components/rcmTableFormItems/wafJa3HashesInput";

import TagSelector from "@/components/FormItems/TagSelector";
import GroupNameSelector from "@/components/FormItems/GroupNameSelector";
import EdgeNameSelector from "@/components/FormItems/EdgeNameSelector";

import FQDNSelector from "@/components/FQDNSelector";
import BatchEditForm from "@/components/BatchEditForm";
import BatchDeleteForm from "@/components/BatchDeleteForm";

import AlertRulesFormExamples from "@/components/AlertRules/FormExamples.vue";
import RolesManageFormExamples from "@/components/RolesManage/FormExamples.vue";
import ScrollsFormExamples from "@/components/Scrolls/FormExamples.vue";
import ScrollsExample from "@/components/Scrolls/ScrollsExample.vue";
import ImportBtn from "@/components/ImportBtn.vue";

import RewriteURLModal from "@/components/FormItems/RewriteURLModal";
import CacheURLModal from "@/components/FormItems/CacheURLModal";
import enumList from "../libs/enumList.js";
import { domainSettingColumns } from "../libs/exportFileColumns.js";

import { transformToWafRuleData } from "../libs/transformToWafRuleData.js";
import SearchDomainAtProfileInput from "@/components/SearchDomainAtProfileInput.vue";

export default {
    components: {
        FormInput,
        FormInputNumber,
        FormSelect,
        FormSwitch,
        FormCheckboxGroup,
        FormRadioGroup,
        FormUpload,
        FormTransfer,
        FormRange,
        FormBoolean,
        FormDatePicker,
        TwoListDraggable,
        OneListDraggable,
        TableList,
        TableCheckbox,
        RawHTML,
        TextOnly,
        HtmlPreview,
        CodeEditor,
        CodeEditorV2,
        CodeEditorV3,
        TagSelector,
        GroupNameSelector,
        EdgeNameSelector,
        FQDNSelector,
        BatchEditForm,
        BatchDeleteForm,
        AlertRulesFormExamples,
        RolesManageFormExamples,
        ScrollsFormExamples,
        ScrollsExample,
        ImportBtn,
        RewriteURLModal,
        CacheURLModal,
        WafHeaderListInput,
        SearchDomainAtProfileInput,
        wafJa3HashesInput
    },
    props: {
        withAfterBulkCreateModal: {},
        esIndex: {},
        esIndexFields: {},
        searchView: {},
        addButtonText: {},
        userCanToggleFuzzySearch: { default: true },
        userCanEditColumns: { default: true },
        userCanEditFilters: { default: true },
        userCanCreate: {},
        userCanIndex: {},
        userCanDelete: {},
        userCanBatchEdit: {},
        userCanBatchDelete: {},
        userCanSearchDomain: {},
        userCanSearchByTag: {},
        userCanSearchByGroup: {},
        userCanSearchByEdge: {},
        userCanAdjustTableSize: { default: true },
        isCreateBtnDisabled: { default: false },
        isEditBtnDisabled: { default: false },
        isDeleteBtnDisabled: { default: false },
        isBatchEditBtnDisabled: { default: false },
        isBatchDeleteBtnDisabled: { default: false },
        isSearchAfterBtnEnabled: { default: false },
        userCanExport: { default: true },
        actionInTable: { default: true },
        // tagsQueryString: {},
        sort: { default: () => [{ modifiedDate: { order: "desc" } }] },
        drawerTitleKey: {},
        rowClassInfo: {
            type: Object,
            default: () => ({
                key: "status",
                values: [],
                valuesNot: ["運行中"],
                className: "table-disabled-row",
                defaultClassName: ""
            })
        },
        // drawerWidth: {},
        sectionInfo: { default: () => [] },
        primarySearchKey: {},
        primarySearchKeyI18: {},
        batchSelector: {},
        batchSelectorWith: {},
        withFormExamples: {},
        formExampleComponents: {},
        isFuzzySearch: { default: true },
        givenBatchSearchFilters: { type: Array, default: () => [] },
        externalSearchFilters: { type: Array, default: () => [] },
        isImportCSV: { default: false }
    },
    data() {
        return {
            hasOpenedForm: false,
            remoteSort: this.sort,
            // 頁面參數類, 和props相關
            domainName: "",
            exportFields: {},
            formSections: [],
            formSectionCollapse: ["Essential", "Advanced", "Origins"],
            initFieldsData: [],

            allFormItems: [],
            formData: {},

            allColumns: [],
            tableColumns: [],
            columnsOptions: [],
            tableSize: "default",

            allFilterFormItems: [],
            searchFilters: [],
            searchFilterForm: {},
            // 用來變識使用者是否有填入filter
            defaultSearchFilterForm: {},

            formSlotKeys: [],

            // 頁面參數類, 頁面內部
            isFormShown: false,
            isFilterShown: false,
            isColumnShown: false,
            isBatchEditFormShown: false,
            isBatchDeleteFormShown: false,
            isTableLoading: false,
            tableDataTotal: 0,
            pageSize: 10,
            pageCurrent: 1,
            actionType: "",
            formType: "initForm",
            // selectedItems: [],
            codeEditorChanged: false,

            formDrawerStyles: {
                height: "calc(100% - 120px)",
                overflow: "auto",
                paddingBottom: "53px",
                position: "static"
            },
            formModalStyles: {
                minWidth: "900px",
                marginTop: "20px",
                marginBottom: "20px",
                position: "static"
            },

            tableBtnClass: {
                optBtnIsLoading: []
            },
            isEditBtnLoading: false,

            // 後台回傳類
            getEsResult: {},
            tableData: [],
            // 載入更多
            currentTableDataCapacity: 10000,    
            tableDataLastSortValue: [],
            searchAfterTableData: [],

            modalLoading: true,

            deleteItem: {},
            itemData: {
                "rcm-edges": this.$t("edgesetting.pageTitleText"),
                "rcm-slbs": this.$t("slbsetting.pageTitleText"),
                "rcm-servicegroup": this.$t("servicegroup.pageTitleText"),
                "rcm-originpolicies": this.$t("originPolicy.pageTitleText"),
                "rcm-htmlpages": this.$t("htmlPage.pageTitleText"),
                "rcm-app-profiles": this.$t("routesMenu.AppProfile"),
                "rcm-nginxconfigs": this.$t("routesMenu.DomainManage"),
                "rcm-wafrules": this.$t("wafrules.pageTitleText"),
                "rcm-users": this.$t("usersmanage.pageTitleText"),
                "rcm-owasprules": this.$t("owasp.pageTitleText")
            },
            selectFileData: {},
            exportAppProfileModal: false,
            exportAppProfileType: "exportAppProfile"
        };
    },
    mounted() {
        // 獲取所有物件
        this.initFields();
        // 初始化column類
        this.allColumns = this.initColumns();
        this.tableColumns = this.getTableColumns();
        // 初始化表單類
        this.allFormItems = this.initFormItems();
        this.initFormSections();
        // 初始化filter類
        this.allFilterFormItems = this.initFilterFormItems();
        this.searchFilterForm = this.initSearchFilterForm();
        this.defaultSearchFilterForm = Object.assign({}, this.searchFilterForm);

        this.getTableData();
        bus.$on("reloadTable", () => {
            this.getTableData();
        });
    },
    methods: {
        onRcmTableSortchange(data) {
            let { column, key, order } = data;

            if (order == "normal") {
                this.remoteSort = [];
            } else {
                let sortObj = {};
                sortObj[key] = { order };
                this.remoteSort = [sortObj];
            }

            this.getTableData();
        },
        onSearchDomainAtProfileResult({ tableData, total, esResult }) {
            this.tableData = tableData;
            this.tableDataTotal = total;
            this.getEsResult = esResult;
        },
        onSearchDomainAtProfileError(err) {
            this.$Message.error("搜尋失敗");
            console.log(err);
        },
        isPanelShown(index, formData) {
            let showItems = this.formSections[index].sectionItems.filter(item => item.vShowFieldVal(formData) == 1);
            return showItems.length > 0 ? true : false;
        },
        batchEditSubmitComplete() {
            this.isBatchEditFormShown = false;
            this.getTableData();
        },
        batchDeleteSubmitComplete() {
            this.isBatchDeleteFormShown = false;
            this.getTableData();
        },
        getFilterResult() {
            // 清除「載入更多」所更動的變數
            this.currentTableDataCapacity = 10000;
            this.tableDataLastSortValue = [];
            this.searchAfterTableData = [];

            this.pageCurrent = 1;
            this.getTableData();
            this.isFilterShown = false;
        },
        clearFilter() {
            this.searchFilterForm = Object.assign({}, this.defaultSearchFilterForm);
            this.isFilterShown = false;
            this.getTableData();
        },
        changePage(currentPage) {
            this.pageCurrent = currentPage;
            // 如果超過 10000 筆，從 this.searchAfterTableData 取得對應資料
            if (currentPage > this.maxPageForLegacyPagination) {
                const diffFromLastPage = currentPage - this.maxPageForLegacyPagination;
                const start = (diffFromLastPage - 1) * this.pageSize;
                // 避免 end 超過實際資料長度（最後一頁可能不足 pageSize）
                const end = Math.min(start + this.pageSize, this.searchAfterTableData.length);
                this.tableData = this.searchAfterTableData.slice(start, end);
                return;
            }

            // 否則走一般搜尋
            this.getTableData();
        },
        changePageSize(pagesize) {
            // 清除「載入更多」所更動的變數
            this.currentTableDataCapacity = 10000;
            this.tableDataLastSortValue = [];
            this.searchAfterTableData = [];

            this.pageSize = pagesize;
            this.getTableData();
        },
        getTableData() {
            this.isTableLoading = true;
            this.searchFilters = this.buildSearchFilters();

            getEsData(this.searchOptions)
                .then(res => {
                    this.getEsResult = res.data;
                    this.tableData = res.data.mapData;
                    this.tableDataTotal = res.data.total;
                    // 已取到 10,000 筆，且尚未記錄最後排序值時，將回傳的 lastSortValue 存起來，以供後續 getSearchAfterTableData() 使用
                    const { from, size } = this.searchOptions;
                    const reachedLegacyPaginationSize = from + size === 10000;
                    const noLastSortValue = this.tableDataLastSortValue.length === 0;
                    if (reachedLegacyPaginationSize && noLastSortValue) {
                        this.tableDataLastSortValue = res.data.lastSortValue;
                    }
                    this.isTableLoading = false;
                })
                .catch(err => {
                    console.log(err);
                    this.tableData = [];
                    this.tableDataTotal = 0;
                    this.tableDataLastSortValue = [];
                    this.isTableLoading = false;
                });
        },
        initFields() {
            var esIndexFieldKeys = Array.isArray(this.esIndexFields)
                ? this.esIndexFields
                : Object.keys(this.esIndexFields);
            //篩選成為最初欄位們
            this.initFieldsData = fieldsData(this)
                // 篩選需要的欄位
                .filter(
                    e =>
                        (e.searchViews.includes(this.searchView) || e.searchViews[0] == "*") &&
                        esIndexFieldKeys.includes(e.key)
                )
                .map(data => {
                    if (data.isFormSlot) this.formSlotKeys.push(data.key);
                    if (Array.isArray(this.esIndexFields)) return data;
                    let overWriteObject = this.esIndexFields[data.key];
                    data = Object.assign(data, overWriteObject);
                    return data;
                })
                .sort((a, b) => esIndexFieldKeys.indexOf(a.key) - esIndexFieldKeys.indexOf(b.key));
            // 如果不要固定某些欄位 就把column的fixed參數刪掉
            if (this.tableWithFixedColumn == false) {
                this.initFieldsData.map(e => {
                    delete e.fixed;
                    return e;
                });
            }
            // 控制table欄位可不可以resize
            this.initFieldsData.map(e => {
                e.resizable = this.resizable;
                return e;
            });
            // 如果可批量新增域名，則為textarea(支援多行)
            if (this.withAfterBulkCreateModal) {
                this.initFieldsData
                    .filter(e => e.key == "servername")
                    .map(data => {
                        data.fieldType = "textarea";
                        return data;
                    });
            }
        },
        initFormItems() {
            let allFormItems = this.initFieldsData
                .filter(data => data.withForm == true)
                .map(formItem => formItemCompletion(formItem));

            return allFormItems;
        },
        initFormSections() {
            // 篩選此頁面section們
            var formSectionKeys = this.allFormItems.map(e => e.sectionKey);

            // 去重複
            formSectionKeys = [...new Set(formSectionKeys)];

            // 初始化section
            // 外部傳入額外資訊
            this.formSections = formSectionKeys.map(sectionKey => {
                let section = this.sectionInfo.find(e => e.sectionKey == sectionKey);
                let sectionName =
                    section && section.sectionName
                        ? section.sectionName
                        : this.$i18n.t(`rcmtable.sections.${sectionKey}`);
                let sectionDescription = section ? section.sectionDescription : "";
                return {
                    sectionKey,
                    sectionName,
                    sectionDescription,
                    sectionItems: []
                };
            });
            // 預設前兩個panel為開啟狀態
            if (this.tableWithModal) {
                this.formSectionCollapse = formSectionKeys;
            } else {
                this.formSectionCollapse = formSectionKeys.slice(0, 2);
            }

            // this.initFormSectionItems();
        },
        initFormSectionItems() {
            this.formSections = this.formSections.map(section => {
                section.sectionItems = this.allFormItems.filter(formItem => {
                    let formTypes = typeof formItem.formTypes == "function" ? formItem.formTypes() : formItem.formTypes;
                    return section.sectionKey == formItem.sectionKey && formTypes.includes(this.formType);
                });
                return section;
            });
        },
        initFormData(item) {
            var formData = {};
            this.allFormItems.forEach(data => {
                let defaultVal = typeof data.defaultVal == "function" ? data.defaultVal(item) : data.defaultVal;
                formData[data.key] = defaultVal;
            });

            return formData;
        },
        initSearchFilterForm() {
            var searchFilterForm = {};

            this.allFilterFormItems.forEach(data => {
                searchFilterForm[data.key] = data.filter.value;
            });

            return searchFilterForm;
        },
        showFiltersForm() {
            this.isFilterShown = true;
        },
        initColumns() {
            let allColumns = this.initFieldsData
                .filter(e => e.withTable !== false)
                .map(columnItem => columnItemCompletion(columnItem, { sort: this.sort }));

            var userColumns = this.$store.state.userSelectedColumns[this.searchView];

            allColumns =
                userColumns && userColumns.length > 0
                    ? allColumns.map(e => {
                          e.showInTable = userColumns.includes(e.key);
                          return e;
                      })
                    : allColumns;
            return allColumns;
        },
        initFilterFormItems() {
            var filterFormItems = this.initFieldsData
                .filter(data => data.filter && data.key !== undefined && data.key !== null && data.key !== "")
                .map(data => {
                    data.filter = filterItemCompletion(data.filter);
                    return data;
                })
                .map(data => formItemCompletion(data))
                .map(data => {
                    data.disabled = data.filterDisabled == true;
                    delete data.watchField;
                    return data;
                });

            return filterFormItems;
        },
        getTableColumns() {
            return this.allColumns.filter(e => e.showInTable == true);
        },
        showColumnsForm() {
            this.isColumnShown = true;
        },
        saveColumns() {
            var userSetShowInTableColumns = this.allColumns.filter(e => e.showInTable == true).map(data => data.key);

            this.$store.commit("SET_SELECTED_COLUMNS", {
                view: this.searchView,
                data: userSetShowInTableColumns
            });
            this.isColumnShown = false;
            this.tableColumns = this.getTableColumns();

            var body = document.body;
            body.style.overflow = "auto";
        },
        createItem() {
            this.formType = "createForm";
            this.initFormSectionItems();
            this.isFormShown = true;
            this.formData = this.initFormData();
            this.formData["actionType"] = "create";
            this.actionType = "create";
        },
        editItem(item) {
            this.formType = "editForm";
            this.initFormSectionItems();
            this.actionType = "edit";
            this.isFormShown = true;
            var defaultFormData = this.initFormData(item);
            this.formData = Object.assign(defaultFormData, item);
            this.formData["actionType"] = "edit";
        },
        copyItem(item) {
            this.createItem();
            this.actionType = "copy";
            var keys = Object.keys(this.formData);
            keys.forEach(element => {
                if (item[element] != undefined) {
                    this.formData[element] = item[element];
                }
            });
        },
        tryOpenAddForm() {
            if (this.hasOpenedForm) return; // 已經開過表單，不重複
            const data = sessionStorage.getItem("wafRulesData");

            if (data) {
                const wafRulesData = JSON.parse(data);
                this.openAddForm(wafRulesData);
                sessionStorage.removeItem("wafRulesData");
                this.hasOpenedForm = true; // 標記為已開過
            }
        },
        openAddForm(item) {
            this.formType = "createForm";
            this.initFormSectionItems();

            this.formData = this.initFormData();
            this.formData["actionType"] = "create";
            this.actionType = "create";

            transformToWafRuleData(item, this.formData);

            this.$nextTick(() => {
                requestAnimationFrame(() => {
                    // 等 DOM 畫面好再顯示表單
                    this.isFormShown = true;
                });
            });
        },
        cancelEdit() {
            // 取消編輯必須將formData註銷
            // 這樣"編輯"時, 才不會觸發queryParams
            this.initFormSections();
            this.formData = {};
            this.isFormShown = false;
            this.getTableData();
            // 清除scolls選擇檔案
            this.selectFileData = {};

            // 獲取所有物件
            this.initFields();
            // 初始化column類
            this.allColumns = this.initColumns();
            this.tableColumns = this.getTableColumns();

            // 初始化表單類
            this.allFormItems = this.initFormItems();
        },
        clickBatchEdit() {
            this.formType = "batchEditForm";
            this.actionType = "batchEdit";
            this.isBatchEditFormShown = true;
        },
        clickBatchDelete() {
            this.formType = "batchDeleteForm";
            this.actionType = "batchDelete";
            this.isBatchDeleteFormShown = true;
        },
        hasBillingPermission() {
            return (
                this.$can("read", "billingPermission", "") &&
                // !this.$store.getters.isAdmin &&
                this.$store.state.platformPlan.multiTenancyConfigs.isAllowPaymentShow
            );
        },
        updateData(esIndex, action, formData) {
            if (Array.isArray(formData)) {
                formData = formData.map(e => {
                    delete e._index;
                    delete e._rowKey;
                    return e;
                });
            } else {
                delete formData._index;
                delete formData._rowKey;
            }
            _updateData(esIndex, action, formData)
                .then(result => {
                    if (action == "bulk-create" && this.withAfterBulkCreateModal) {
                        this.$emit("showAfterBulkCreateModal", true);
                    }
                    this.isEditBtnLoading = false;
                    this.$Notice.success({
                        title: this.$t("global.success"),
                        desc: `${result.data.message}`
                    });
                    this.cancelEdit();
                    // this.getTableData();
                    bus.$emit("reloadTable");
                })
                .catch(error => {
                    let errorObject = Object.assign({}, error);
                    this.$Notice.warning({
                        title: this.$t("global.error"),
                        desc: `${error.data.message}`
                    });
                    if (this.hasBillingPermission()) {
                        if (
                            errorObject.response.data.message == "noPlan" ||
                            errorObject.response.data.message == "noCard"
                        ) {
                            // this.$router.push({ name: "Payment", params: { esIndex } });
                            // this.$store.commit("SET_TRIAL_OBJECTNAME", esIndex);
                            // this.$router.push({ name: "Payment" });
                            this.$store.commit("SET_FAIL_PAYMENT_GROUP", errorObject.response.data.groupInfo);
                            this.$store.commit("SET_isPaymentOpened", true);
                        }
                    }
                    this.isEditBtnLoading = false;
                    this.cancelEdit();
                    bus.$emit("reloadTable");
                });
        },
        validateFormAndSubmit(esIndex) {
            //針對CodeEditorV3.vue，請使用者先按Save File才可以儲存新增編輯表單的內容
            if (this.codeEditorChanged) {
                return this.$Message.error("請點選File > Save File，儲存 Scroll Content 的變更");
            }

            this.$refs.form.validate(valid => {
                if (!valid) {
                    return this.$Message.error("表單有誤!");
                }
                this.isEditBtnLoading = true;
                // 移除 formSlot
                for (let key in this.formData) {
                    if (this.formSlotKeys.includes(key)) {
                        delete this.formData[key];
                    }
                }
                if (this.actionType == "create" || this.actionType == "copy") {
                    this.updateData(esIndex, "create", this.formData);
                } else if (this.actionType == "edit") {
                    var changedItems = {};
                    // 以這次更新的去刷原本資料
                    for (let key in this.formData) {
                        changedItems[key] = this.formData[key];
                    }
                    this.updateData(esIndex, "index", changedItems);
                } else if (this.actionType == "bulk-create") {
                    var bulkCreateData = {};
                    var domains = this.formData.servername.split("\n");
                    bulkCreateData.formData = this.formData;
                    bulkCreateData.bulkItemNames = domains;
                    this.updateData(esIndex, "bulk-create", bulkCreateData);
                }
            });
        },
        async fetchExportData() {
            this.isTableLoading = true;
            // 製作匯出欄位及參數
            let exportFields = {};
            let fieldsCanExport = [];
            this.pageCurrent = 1;
            let response = {};
            const isAdmin = this.$store.getters.isAdmin;

            // appProfile且是匯出內部domain
            if (
                this.searchView === "AppProfile" &&
                this.exportAppProfileType === enumList.exportAppProfileType.APP_PROFILE_DOMAIN
            ) {
                const allFieldData = fieldsData(this);

                // domain setting 欄位
                let exportDomainFields = isAdmin
                    ? { ...domainSettingColumns.admin }
                    : { ...domainSettingColumns.normalUser };

                // 放入相關欄位資料
                allFieldData.forEach(e => {
                    if (exportDomainFields[e.key]) {
                        exportDomainFields[e.key] = e;
                    }
                });

                Object.keys(exportDomainFields).forEach(key => {
                    fieldsCanExport.push(exportDomainFields[key]);
                });

                fieldsCanExport = fieldsCanExport.map(columnItem =>
                    columnItemCompletion(columnItem, { sort: this.sort })
                );

                let searchBody = Object.assign({}, this.searchOptions);
                searchBody.size = this.tableDataTotal > 10000 ? 10000 : this.tableDataTotal;
                searchBody.exportAllDomainsData = true;
                searchBody.exportData = true;
                response = await getEsData(searchBody);
            } else {
                fieldsCanExport = this.allColumns;
                let maxDownloadNumber = this.tableDataTotal > 10000 ? 10000 : this.tableDataTotal;

                // 如為憑證下載，超過最大下載數量顯示警告，並設定下載數量
                if (this.searchView === "CertsManage" && this.tableDataTotal > enumList.MAX_CERT_DOWNLOAD_NUMBER) {
                    this.$Message.warning(
                        this.$i18n.t("rcmtable.exceedMaxDownloadNumber", { limit: enumList.MAX_CERT_DOWNLOAD_NUMBER })
                    );
                    maxDownloadNumber = enumList.MAX_CERT_DOWNLOAD_NUMBER;
                }
                this.searchOptions.size = maxDownloadNumber;
                this.searchOptions.exportData = true;
                response = await getEsData(this.searchOptions);
                if (!response.data.success) {
                    this.$Message.error(response.data.message);
                }
            }

            // 製作匯出資料欄位
            fieldsCanExport
                .filter(e => e.exportOptions.canExport && !e.isFormSlot)
                .forEach(field => {
                    exportFields[field.key] = {
                        field: field.key,
                        callback: field.exportOptions.callback
                    };
                });
            this.exportFields = exportFields;

            // 依據物件補齊欄位
            switch (this.searchView) {
                case "ProfileDomain":
                case "DomainSetting":
                    response.data.mapData = response.data.mapData.map(data => ({
                        ...data,
                        cnameInfo: data.cnameto
                    }));
                    break;
                case "AlertRules":
                    response.data.mapData = response.data.mapData.map(data => ({
                        ...data,
                        alertValueInfo: `${data.currentValue} ${data.alertWhen} ${data.alertValue} ${data.alertValueUnit}`
                    }));
                    break;
                case "SlbSetting":
                case "EdgeSetting":
                case "NinjaSetting":
                    let prefix = `${this.searchView.replace("Setting", "").toLowerCase()}`;
                    response.data.mapData = response.data.mapData.map(data => ({
                        ...data,
                        connectState: this.$parent.viewSlotInfo[`${prefix}clients`].includes(data._id)
                    }));
                    break;
                case "GroupResource":
                    const usageFormat = (created, maximum) => `${created} / ${maximum}`;
                    response.data.mapData = response.data.mapData.map(data => ({
                        ...data,
                        paymentStatus: data.billing ? data.billing.paymentStatus : false,
                        FQDNConfigUsage: usageFormat(data.createdFQDNConfigCount, data.maxFQDNConfigCount),
                        appProfileUsage: usageFormat(data.createdAppProfileCount, data.maxAppProfileCount),
                        userUsage: usageFormat(data.createdUserCount, data.maxUserCount),
                        serverNameUsage: usageFormat(data.createdServerNameCount, data.maxServerNameCount),
                        wafRuleUsage: usageFormat(data.createdWafRuleCount, data.maxWafRuleCount),
                        alertRuleUsage: usageFormat(data.createdAlertRuleCount, data.maxAlertRuleCount),
                        htmlPageUsage: usageFormat(data.createdHtmlPageCount, data.maxHtmlPageCount),
                        originPolicyUsage: usageFormat(data.createdOriginPolicyCount, data.maxOriginPolicyCount),
                        serviceGroupUsage: usageFormat(data.createdServiceGroupCount, data.maxServiceGroupCount)
                    }));
                    break;
                case "UsersManage":
                    response.data.mapData = response.data.mapData.map(data => {
                        let trustedIpAndDevice =
                            data.userAllowEquipList && data.userAllowEquipList.length > 0
                                ? data.userAllowEquipList.map(item => {
                                      return `IP: ${item.ip} - Device: ${item["user-agent"]}`;
                                  })
                                : [];
                        return {
                            ...data,
                            trustedIpAndDevice: JSON.stringify(trustedIpAndDevice)
                        };
                    });
                    break;
                case "Tasks":
                    response.data.mapData = response.data.mapData.map(data => ({
                        ...data,
                        diffData: JSON.stringify(diff(JSON.parse(data.originData), JSON.parse(data.requestData)))
                    }));
                    break;
                default:
                    break;
            }
            const exportData = response.data.mapData;
            this.isTableLoading = false;
            return exportData;
        },
        rowClassName(row, index) {
            if (this.rowClassInfo !== undefined) {
                if (this.rowClassInfo.values.includes(row[this.rowClassInfo.key])) return this.rowClassInfo.className;
                if (!this.rowClassInfo.valuesNot.includes(row[this.rowClassInfo.key]))
                    return this.rowClassInfo.className;
                if (this.rowClassInfo.defaultClassName !== "") return this.rowClassInfo.defaultClassName;
            }
            return "";
        },
        buildSearchFilters() {
            var searchFilters = [];
            for (let filterKey in this.searchFilterForm) {
                let inputValue = this.searchFilterForm[filterKey];
                let defaultFilterType = filterKey == "tags" ? "select" : "string";
                let filterFormItem = this.allFilterFormItems.find(e => e.key == filterKey) || {
                    filter: { type: defaultFilterType }
                };

                let hasUserInput = false;

                switch (filterFormItem.filter.type) {
                    case "number":
                    case "string":
                    case "select":
                    case "object":
                    case "boolean":
                        if (inputValue.toString().length > 0) hasUserInput = true;
                        break;
                    case "date":
                        if (inputValue[0].toString().length > 0) hasUserInput = true;
                        break;
                    case "range":
                        if ((inputValue.gt && inputValue.gt !== null) || (inputValue.lt && inputValue.lt !== null))
                            hasUserInput = true;
                        break;
                }

                // 有些欄位須特別指定搜尋欄位
                let searchKey = filterFormItem.filter.searchKey || filterKey;

                if (hasUserInput && filterFormItem.filter.type == "object") {
                    try {
                        let dataObject = inputValue.split("/\n/");
                        dataObject = dataObject[0].split("\n");
                        dataObject.forEach(e => {
                            let keyData = e.replace(/\s*/g, "").split(/:(.+)/);
                            let key = keyData[0].trim();
                            let value = keyData[1].trim();
                            searchFilters.push({
                                key: searchKey + "." + key,
                                type: "string",
                                value: value
                            });
                        });
                    } catch (error) {
                        console.log(error);
                    }
                } else if (hasUserInput) {
                    // searchFilters.push(filterFormItem.filter);
                    searchFilters.push({
                        key: searchKey,
                        type: filterFormItem.filter.type,
                        value: inputValue
                    });
                }
            }
            return searchFilters;
        },
        openPaymentModal() {
            this.$store.commit("SET_isPaymentOpened", false);
            // this.$router.push({ name: "Payment", params: { paymentSeat: 0 } });
            this.$router.push({ name: "Payment", query: { groupName: this.$store.state.failPaymentGroup.groupName } });
        },
        closeModalEvent() {
            this.$store.commit("SET_isPaymentOpened", false);
        },
        selectExample(event) {
            delete event[this.primarySearchKey];
            this.formData = Object.assign(this.formData, event);
        },
        setSelectFileData(selectFileData) {
            this.selectFileData = selectFileData;
        },
        codeChangedNotSave(value) {
            this.codeEditorChanged = value;
            // console.log("codeEditorChanged", this.codeEditorChanged);
        },
        calculatePagination(requestedFrom, requestedSize, maxSize) {
            if (requestedFrom >= maxSize) {
                return {
                    from: 0,
                    size: requestedSize
                };
            }

            const availableSize = maxSize - requestedFrom;

            const adjustedSize = Math.min(requestedSize, availableSize);

            return {
                from: requestedFrom,
                size: adjustedSize
            };
        },
        getSearchAfterTableData() {
            this.isTableLoading = true;
            const searchOptions = {
                ...this.searchOptions,
                from: 0,
                search_after: this.tableDataLastSortValue,
                globalFrom: this.currentTableDataCapacity
            };
            getEsData(searchOptions)
                .then(res => {
                    this.searchAfterTableData.push(...res.data.mapData);
                    this.tableDataLastSortValue = res.data.lastSortValue;
                    this.currentTableDataCapacity += this.pageSize;
                    this.isTableLoading = false;
                })
                .catch(err => {
                    console.log(err);
                    this.isTableLoading = false;
                });
        }
    },
    watch: {
        esIndexFields: {
            deep: true,
            handler: function() {
                // 獲取所有物件
                this.initFields();
                // 初始化column類
                this.allColumns = this.initColumns();
                this.tableColumns = this.getTableColumns();
                this.getTableData();
            }
        },
        isTableLoading(newVal) {
            if (newVal === false) {
                this.tryOpenAddForm();
            }
        }
    },
    computed: {
        resizable() {
            return this.$store.getters.getTableConfig.resizable;
        },
        withBorder() {
            return this.$store.getters.getTableConfig.withBorder;
        },
        withIcon() {
            return this.$store.getters.getTableConfig.actionWithIcon;
        },
        totalCountStyle() {
            return { float: this.$store.getters.getTableConfig.paginationPosition, margin: "5px 10px 0 0" };
        },
        paginationStyle() {
            return { textAlign: this.$store.getters.getTableConfig.paginationPosition };
        },
        tableHeaderStyle() {
            return this.$store.getters.getTableConfig.headerStyle;
        },
        tableWithModal() {
            return this.$store.getters.getTableConfig.withModal;
        },
        tableWithFixedColumn() {
            return this.$store.getters.getTableConfig.fixedColumn;
        },
        editingItems() {
            switch (this.formType) {
                case "createForm":
                    return { formType: this.formType, items: [this.formData] };
                    break;
                case "editForm":
                    return { formType: this.formType, items: [this.formData] };
                    break;
                default:
                    return { formType: this.formType, items: [] };
            }
        },
        formTitle() {
            switch (this.actionType) {
                case "edit":
                    if (this.formData[this.drawerTitleKey] == undefined) {
                        return `${this.$i18n.t("rcmtable.editText")}`;
                    }
                    let itemTitle = this.formData[this.drawerTitleKey];
                    return `${this.$i18n.t("rcmtable.editText")} ${itemTitle}`;
                    break;
                case "copy":
                    return this.$i18n.t("rcmtable.copyText");
                    break;
                case "create":
                    return this.$i18n.t("rcmtable.createText");
                    break;
            }
        },
        formDescription() {
            var formDescription =
                this.esIndexFields.settingZoneExplain !== undefined
                    ? this.esIndexFields.settingZoneExplain.description
                    : "<p></p>";

            if (formDescription) return formDescription;
        },
        searchOptions() {
            const pageFrom = this.pageSize * (this.pageCurrent - 1);
            const maxSize = enumList.ES_SEARCH_MAX_SIZE;
            const { from, size } = this.calculatePagination(pageFrom, this.pageSize, maxSize);

            var options = {
                isFuzzySearch: this.isFuzzySearch,
                esIndex: this.esIndex,
                from,
                size,
                sort: this.remoteSort,
                filters: this.externalSearchFilters.length > 0 ? this.externalSearchFilters : this.searchFilters,
                searchView: this.searchView || ""
            };
            return options;
        },
        isSaveBtnDisabled() {
            var currentTableColumns = this.getTableColumns().map(e => e.key);
            var storedTableColumns = this.$store.state.userSelectedColumns[this.searchView] || [];
            return JSON.stringify(currentTableColumns.sort()) == JSON.stringify(storedTableColumns.sort());
        },
        hasUserInputFilter() {
            return JSON.stringify(this.defaultSearchFilterForm) !== JSON.stringify(this.searchFilterForm) ? 1 : 0;
        },
        modalTitle() {
            let cardId = this.$store.state.userPaymentInfo.cardId;
            let failPaymentGroup = this.$store.state.failPaymentGroup;
            if (failPaymentGroup != "") {
                cardId = failPaymentGroup.billing.cardId;
            }
            let title = this.$t("accountInfo.remind.exceededQtyText");
            if (!cardId) {
                title = this.$t("accountInfo.remind.titleSetCardText");
            }
            return title;
        },
        modalBody() {
            let cardId = this.$store.state.userPaymentInfo.cardId;
            let failPaymentGroup = this.$store.state.failPaymentGroup;
            if (failPaymentGroup != "") {
                cardId = failPaymentGroup.billing.cardId;
            }
            let itemName = this.esIndex;
            itemName = this.itemData[itemName];
            let descriptionOne = `${this.$t("accountInfo.remind.descriptionOneYourText")} ${itemName} ${this.$t(
                "accountInfo.remind.descriptionOneText"
            )} [${this.planName}] `;
            let descriptionTwo = this.$t("accountInfo.remind.descriptionTwoneText");
            if (!cardId) {
                descriptionOne = this.$t("accountInfo.error.noCardText");
                descriptionTwo = ``;
            }
            return { descriptionOne, descriptionTwo };
        },
        planName() {
            return this.$t("accountInfo.basic");
        },
        fieldsData() {
            return this.initFieldsData.filter(e => {
                if (e.validate) {
                    if (typeof e.formTypes == "function") {
                    } else if (e.formTypes.includes("createForm") && e.validate) {
                        return e;
                    }
                }
            });
        },
        showSearchAfterBtn() {
            return (
                this.isSearchAfterBtnEnabled && // 啟用 search_after
                this.pageCurrent >= this.maxPageForLegacyPagination && // 已翻到一般分頁機制（search）的最後一頁
                this.currentTableDataCapacity <= this.tableDataTotal // 還沒撈完所有資料
            );
        },
        maxPageForLegacyPagination() {
            const total = this.tableDataTotal < 10000 ? this.tableDataTotal : 10000;
            return Math.ceil(total / this.pageSize);
        }
    },
    beforeDestroy() {
        bus.$off("reloadTable");
    }
};
</script>
<style scoped>
.flex {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}
.button {
    margin-right: 8px;
}
.table {
    margin: 10px 0px;
}
.formDrawer {
    height: calc(100% - 120px);
    overflow: auto;
    position: static;
    padding-bottom: 53px;
}
.filterFormItem {
    margin-bottom: 0;
}
.formDescription {
    margin-bottom: 20px;
}
.formItemDescription {
    margin: 15px 0;
    line-height: 20px;
}
.footer {
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    border-top: 1px solid #e8e8e8;
    padding: 15px 16px;
    background: #fff;
}
.footerActionRight {
    text-align: right;
}
.footerActionLeft {
    text-align: left;
}
.section-description {
    margin-bottom: 16px;
}
.modalForm >>> .ivu-collapse-header {
    pointer-events: none;
}
/deep/ .ivu-form-item-error-tip {
    white-space: break-spaces;
}
</style>



// WEBPACK FOOTER //
// src/components/RcmTable_v2.vue